<template>
	<div class="content">
		<div class="head">
			<div class="head_left">
				<div class="img">
					<img :src="avatar_img" v-if="avatar_img != ''"/>
				</div>
				<div class="head_center">
					<div class="phone">
						{{userInfo.email?userInfo.username:userInfo.phone}}
					</div>
					<div class="lv_box">
						<div class="vip" v-if="vipInfo.active==0||vipInfo.active>=1" :class="{notActive:vipInfo.active!=1}">{{vipInfo.level | vip_level}}</div>
						<div class="representative" v-if="vipInfo.role_type==1">{{$t('system.representative')}}</div>
					</div>
				</div>
			</div>
			<!-- <div class="head_right">
				<div class="icon"><img src="../../assets/imgs/new_color/tiaozhuan.png" /></div>
			</div> -->
		</div>
		<!-- 开通会员享福利 -->
		<!-- <div class="K_VIP">
			<div class="main7">
			  <div class="section5">
				  <img src="../../assets/imgs/new_color/vip@2x.png" >
				  <span class="word7">{{$t('system.kaitongvipxiangfuli')}}</span>
			  </div>
			  <div class="section6" @click="routreTo('/memberClub')">
				<span class="word8">{{$t('system.lijikaitong')}}</span>
			  </div> -->
			  <!-- <div class="section6" @click="routreTo('/community2')">
					<span class="word8">{{$t('system.lijikaitong')}}</span>
			  </div> -->
			<!-- </div>
		</div> -->
		<div class="seation">
			<div class="qb" @click="routreTo('/assets')">
			  <div class="qb_left">
				  <img src="../../assets/imgs/new_color/qianbao@2x.png" >
				  <span class="word7">{{$t('xinzeng.qianbao')}}</span>
			  </div>
			  <div class="qb_right">
				  <span class="word7">{{assetsDitale}} USDT</span>
			      <img src="../../assets/imgs/new_color/tiaozhuan.png" >
			  </div>
			</div>
		</div>

		<!-- 邀请好友 -->
		<div class="seation1">
			 <!-- v-if="vipInfo.active" -->
			<div class="qb" @click="routreTo('/sharePage')">
			  <div class="qb_left">
				  <img src="../../assets/imgs/new_color/yaoqing@2x.png" >
				  <span class="word7">{{$t('system.invitefriends')}}</span>
			  </div>
			  <div class="qb_right">
			      <img src="../../assets/imgs/new_color/tiaozhuan.png" >
			  </div>
			</div>
			<!-- <div class="qb" @click="routreTo('/tobeVip')" v-else>
			  <div class="qb_left">
				  <img src="../../assets/imgs/new_color/yaoqing@2x.png" >
				  <span class="word7">{{$t('system.invitefriends')}}</span>
			  </div>
			  <div class="qb_right">
			      <img src="../../assets/imgs/new_color/tiaozhuan.png" >
			  </div>
			</div> -->
		</div>
		<div class="seation2">
			<div class="qb" @click="routreTo('/community2')">
			  <div class="qb_left">
				  <img src="../../assets/imgs/new_color/team@2x.png" >
				  <span class="word7">{{$t('system.myteam')}}</span>
			  </div>
			  <div class="qb_right">
			      <img src="../../assets/imgs/new_color/tiaozhuan.png" >
			  </div>
			</div>
		</div>
		<div class="seation3">
			<div class="qb" @click="recordsORjournal">
			  <div class="qb_left">
				  <img src="../../assets/imgs/new_color/jilu@2x.png" >
				  <span class="word7">{{$t('system.TransactionRecord')}}</span>
			  </div>
			  <div class="qb_right">
			      <img src="../../assets/imgs/new_color/tiaozhuan.png" >
			  </div>
			</div>
		</div>
		<!-- <div class="seation4">
			<div class="qb">
			  <div class="qb_left">
				  <img src="../../assets/imgs/new_color/gongju@2x.png" >
				  <span class="word7">{{$t('system.tool')}}</span>
			  </div>
			  <div class="qb_right">
			      <img src="../../assets/imgs/new_color/tiaozhuan.png" >
			  </div>
			</div>
		</div> -->

		<div class="seation5">
			<div class="qb" @click="routreTo('/securityCenter')">
			  <div class="qb_left">
				  <img src="../../assets/imgs/new_color/anquanzhongxin@2x.png" >
				  <span class="word7">{{$t('system.Securitycenter')}}</span>
			  </div>
			  <div class="qb_right">
			      <img src="../../assets/imgs/new_color/tiaozhuan.png" >
			  </div>
			</div>
		</div>
		<div class="seation6">
			<div class="qb" @click="routreToParams('consultingService',{active:'1'})">
			  <div class="qb_left">
				  <img src="../../assets/imgs/new_color/zixun@2x.png" >
				  <span class="word7">{{$t('system.article')}}</span>
			  </div>
			  <div class="qb_right">
			      <img src="../../assets/imgs/new_color/tiaozhuan.png" >
			  </div>
			</div>
		</div>
		<div class="seation7">
			<div class="qb" @click="routreTo('/aboutOurs')">
			  <div class="qb_left">
				  <img src="../../assets/imgs/new_color/aboutour@2x.png" >
				  <span class="word7">{{$t('system.aboutus')}}</span>
			  </div>
			  <div class="qb_right">
			      <img src="../../assets/imgs/new_color/tiaozhuan.png" >
			  </div>
			</div>
		</div>
		<div class="login_out" @click="logOut">{{$t('system.tuichudenglu')}}</div>
		<div class="kong"></div>
		<van-tabbar v-model="active" active-color="#EFBA0D" inactive-color="#ACB5BC" route safe-area-inset-bottom>
		  <van-tabbar-item replace to="/">
		    <span>{{ $t('common.home') }}</span>
		    <template #icon="props">
		      <img v-if="props.active" src="../../assets/imgs/new_color/home_a.png" />
			  <img v-else src="../../assets/imgs/new_color/home.png" />
		    </template>
		  </van-tabbar-item>
		 <van-tabbar-item replace to="/quantification">
		    <span>{{ $t('system.quant') }}</span>
		    <template #icon="props">
		      <img v-if="props.active" src="../../assets/imgs/new_color/lianghua_a.png" />
		      <img v-else src="../../assets/imgs/new_color/lianghua.png" />
		    </template>
		  </van-tabbar-item>
		  <van-tabbar-item replace to="/my">
		    <span>{{ $t('xinzeng.wode') }}</span>
		    <template #icon="props">
		      <img v-if="props.active" src="../../assets/imgs/new_color/my_a.png" />
		      <img v-else src="../../assets/imgs/new_color/my.png" />
		    </template>
		  </van-tabbar-item>
		</van-tabbar>
		
	</div>
</template>

<script>
	import listIconArr from '@/components/list/listIconArr.vue'
	import { logout } from "@/router/index.js"
	export default {
		data() {
			return {
				active: 2,
				userInfo: {},
				expire_day: '',
				activeIfVar: false,
				helpId: '',
				vipInfo: {},
				avatar_img: '',
				tab_index: 2,
				exchangeMap: {
					huobi: 1,
					bian: 2,
					okex: 3,
					uniswap: 4
				},
				exchange: '',
				jiaoyiLX : 'spot', 
				assetsDitale: 0, //可用货币余额
				StatusbarHeight: ''
			}
		},
		filters: {
			vip_level(v) {
				if(v == -1) {
					return 'VIP0'
				}else if(v == 2 || v == 3 || v == 4) {
					return this.$t('system.vip'+v)
				}else if(v >6) {//合伙人
					return this.$t('system.partner')
				}else {
					return 'VIP'+v;
				}
			}
		},
		mounted() {
			// 获取用户信息
			let userinfo = JSON.parse(localStorage.getItem('userInfo'))
			this.userInfo = userinfo
			this.exchange = userinfo.default_exchange;
			this.getAssets();
			// console.log(userinfo)
		},
		created() {
			this.getClubMemberInfo();
			this.GetSystemImgList();
		},
		methods: {
			routreTo(e) {
				this.$router.push(e)
			},
			routreToParams(name,params) {
				this.$router.push({
					name,
					params
				})
			},
			recordsORjournal(e) {
				this.$router.push({
					path:'/recordsORjournal',
					query:{
						tab:0,
					}
				})
			},
			tab_qie(e) {
				this.tab_index = e;
				if (e == 0) {
					this.$router.push('/newHome');
				} else if (e == 1) {
					this.$router.push('/quantification');
				} else if (e == 2) {
					this.$router.push('/my');
				}
			},
			// 验证是否为会员用户，获取用户会员等级信息
			getClubMemberInfo() {
				this.$post2('User/Api/Index/getClubInfo', {}).then(res => {
					this.vipInfo = res;
					// console.log('vipInfo', this.vipInfo)
				});
			},
			// 获取资产信息
			getAssets() {
			  this.$post2("User/Api/Index/userAsset").then((res) => {
			    console.log(res);
			    // 总资产是 amout + frozen
			
			    let t = res.USDT.amount + res.USDT.frozen;
			    this.assetsDitale = t.toFixed(2);
			    // let t2 = res.REWARD.amount + res.REWARD.frozen;
			    // this.rewardData = t2.toFixed(2);
			    // console.log(typeof res.USDT.amount)
			    // this.amount =  res.amount
			    // + res.frozen
			  });
			},
			logOut() {
				console.log('logOut')
				this.$post2("user/api/passport/logout", {})
				    .then(res => {
				        logout()
				    })
			},
			//获取logo图
			GetSystemImgList() {
				this.$post2('User/Api/Passport/GetSystemImgList  ', {})
					.then(res => {
						this.avatar_img = res.list[0].url;
					})
					.catch(e => {
						// this.$toast.fail(e);
					});
			}
		},
	}
</script>

<style scoped lang="less">
	.content {
		font-family: PingFangSC-Regular;
		// padding-bottom: 1.6rem;
		// font-family: PingFangSC-Medium;
		min-height:100%;
	}
	.head {
		padding-top: 0.45rem;
		padding-top: calc(env(safe-area-inset-top) + 0.45rem);
		// margin: 0 0.6rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 0.64rem;

		position: relative;
		left: 0;
		width: 100%;
		margin-bottom: 0.85rem;
		&::before{
			content: "";
			height: 3.16rem;
			height: calc(env(safe-area-inset-top) + 3.16rem);
			width: 100%;
			background: url(../../assets/imgs/new_color/my_head_bg.png) no-repeat center top;
			background-size: 100% 100%;
			display: inline-block;
			position: absolute;
			top: 0;
		}
		.head_left {
			z-index: 100;
			margin-left: 1.2rem;
			display: flex;
			align-items: center;

			margin-top: 0.85rem;
			margin-bottom: 0.26rem;
			.head_center {
				margin-left: 0.36rem;
				.phone {
					color: #333333;
					font-size: 0.28rem;
					font-weight: 500;
					text-align: left;
				}
				.lv_box{
					display: flex;
					align-items: center;
					margin-top: 2px;
					.vip {
						width: 0.9rem;
						height: 0.37rem;
						border-radius: 0.27rem;
						font-size: 0.24rem;
						text-align: center;
						line-height: 0.37rem;
						color: #D7B986;
						// background-image: url(../../assets/imgs/new_color/VIP_bg.png);
						// background-size: 0.9rem 0.37rem;
						// background-repeat: no-repeat;
					}
					.representative{
						padding: 0 10px;
						margin-left: 8px;
					}
					div{
						border-radius: 0.27rem;
						font-size: 0.24rem;
						height: 0.37rem;
						color: #D7B986;
						background: #6a5e4e;
						display: flex;
						justify-content: center;
						align-items: center;
					}
					.notActive{
						background: #909399;
						color: #e8ecff;
					}
				}
			}
			.img {
				width: 1rem;
				height: 1rem;
				img {
					width: 100%;
					height: 100%;
					border-radius: 50%;
				}
			}
		}
		.head_right {
			margin-right: 0.6rem;
			.icon {
				img {
					width: 0.19rem;
					height: 0.32rem;
				}
			}
		}
	}
	.K_VIP {
		margin: 0 0.2rem;
		// margin-top: 0.64rem;
		border-radius: 0.16rem;
		padding: 0.05rem 0;
		background-image: linear-gradient(to left,#DDC399, #EAD7BA);
		.main7 {
			padding: 0.06rem;
			margin: 0 0.4rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.section5 {
				display: flex;
				align-items: center;
				img {
					width: 0.8rem;
					height: 0.64rem;
				}
				.word7 {
					// margin-left: 0.2rem;
					color: #8A7048;
					font-size: 0.24rem;
				}
			}
			.section6 {
				background-image: linear-gradient(to right,#C7A46F, #D8BA91);
				border-radius: 0.35rem;
				width: 1.69rem;
				height: 0.5rem;
				line-height: 0.45rem;
				text-align: center;
				.word8 {
					font-size: 0.24rem;
					color: #8A7048;
				}
			}
		}
	}
	.seation {
		margin: 0 0.2rem;
		margin-top: 0.2rem;
		border-radius: 0.16rem;
		height: 1.11rem;
		line-height: 1.11rem;
		background-color: #FFFFFF;
		.qb {
			margin: 0 0.2rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.qb_left {
				display: flex;
				align-items: center;
				img {
					width: 0.6rem;
					height: 0.6rem;
				}
				.word7 {
					font-family: PingFangSC-Regular;
					margin-left: 0.12rem;
					color: #6F7989;
					font-size: 0.28rem;
				}
			}
			.qb_right {
				display: flex;
				align-items: center;
				img {
					margin-left: 0.4rem;
					width: 0.14rem;
					height: 0.24rem;
				}
				.word7 {
					font-family: PingFangSC-Medium;
					color: #333333;
					font-weight: bold;
					font-size: 0.32rem;
				}
			}
		}
	}
	
	.seation1 {
		margin: 0 0.2rem;
		margin-top: 0.2rem;
		border-top-left-radius: 0.16rem;
		border-top-right-radius: 0.16rem;
		height: 1rem;
		line-height: 1rem;
		background-color: #FFFFFF;
		.qb {
			margin: 0 0.2rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.qb_left {
				display: flex;
				align-items: center;
				img {
					width: 0.6rem;
					height: 0.6rem;
				}
				.word7 {
					font-family: PingFangSC-Regular;
					margin-left: 0.12rem;
					color: #6F7989;
					font-size: 0.28rem;
				}
			}
			.qb_right {
				display: flex;
				align-items: center;
				img {
					margin-left: 0.4rem;
					width: 0.14rem;
					height: 0.24rem;
				}
				.word7 {
					color: #333333;
					font-weight: 500;
					font-size: 0.32rem;
				}
			}
		}
	}
	.seation2 {
		margin: 0 0.2rem;
		// margin-top: 0.2rem;
		height: 1rem;
		line-height: 1rem;
		background-color: #FFFFFF;
		.qb {
			margin: 0 0.2rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.qb_left {
				display: flex;
				align-items: center;
				img {
					width: 0.6rem;
					height: 0.6rem;
				}
				.word7 {
					font-family: PingFangSC-Regular;
					margin-left: 0.12rem;
					color: #6F7989;
					font-size: 0.28rem;
				}
			}
			.qb_right {
				display: flex;
				align-items: center;
				img {
					margin-left: 0.4rem;
					width: 0.14rem;
					height: 0.24rem;
				}
				.word7 {
					color: #333333;
					font-weight: 500;
					font-size: 0.32rem;
				}
			}
		}
	}
	.seation3 {
		margin: 0 0.2rem;
		border-bottom-left-radius: 0.16rem;
		border-bottom-right-radius: 0.16rem;
		height: 1rem;
		line-height: 1rem;
		background-color: #FFFFFF;
		.qb {
			margin: 0 0.2rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.qb_left {
				display: flex;
				align-items: center;
				img {
					width: 0.6rem;
					height: 0.6rem;
				}
				.word7 {
					margin-left: 0.12rem;
					color: #6F7989;
					font-size: 0.28rem;
				}
			}
			.qb_right {
				display: flex;
				align-items: center;
				img {
					margin-left: 0.4rem;
					width: 0.14rem;
					height: 0.24rem;
				}
				.word7 {
					color: #333333;
					font-weight: 500;
					font-size: 0.32rem;
				}
			}
		}
	}
	.seation4 {
		margin: 0 0.2rem;
		margin-top: 0.2rem;
		border-top-left-radius: 0.16rem;
		border-top-right-radius: 0.16rem;
		height: 1rem;
		line-height: 1rem;
		background-color: #FFFFFF;
		.qb {
			margin: 0 0.2rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.qb_left {
				display: flex;
				align-items: center;
				img {
					width: 0.6rem;
					height: 0.6rem;
				}
				.word7 {
					font-family: PingFangSC-Regular;
					margin-left: 0.12rem;
					color: #6F7989;
					font-size: 0.28rem;
				}
			}
			.qb_right {
				display: flex;
				align-items: center;
				img {
					margin-left: 0.4rem;
					width: 0.14rem;
					height: 0.24rem;
				}
				.word7 {
					color: #333333;
					font-weight: 500;
					font-size: 0.32rem;
				}
			}
		}
	}
	.seation5 {
		margin: 0 0.2rem;
		margin-top: 0.2rem;
		height: 1rem;
		line-height: 1rem;
		background-color: #FFFFFF;
		.qb {
			margin: 0 0.2rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.qb_left {
				display: flex;
				align-items: center;
				img {
					width: 0.6rem;
					height: 0.6rem;
				}
				.word7 {
					font-family: PingFangSC-Regular;
					margin-left: 0.12rem;
					color: #6F7989;
					font-size: 0.28rem;
				}
			}
			.qb_right {
				display: flex;
				align-items: center;
				img {
					margin-left: 0.4rem;
					width: 0.14rem;
					height: 0.24rem;
				}
				.word7 {
					color: #333333;
					font-weight: 500;
					font-size: 0.32rem;
				}
			}
		}
	}
	
	.seation6 {
		margin: 0 0.2rem;
		height: 1rem;
		line-height: 1rem;
		background-color: #FFFFFF;
		.qb {
			margin: 0 0.2rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.qb_left {
				display: flex;
				align-items: center;
				img {
					width: 0.6rem;
					height: 0.6rem;
				}
				.word7 {
					font-family: PingFangSC-Regular;
					margin-left: 0.12rem;
					color: #6F7989;
					font-size: 0.28rem;
				}
			}
			.qb_right {
				display: flex;
				align-items: center;
				img {
					margin-left: 0.4rem;
					width: 0.14rem;
					height: 0.24rem;
				}
				.word7 {
					color: #333333;
					font-weight: 500;
					font-size: 0.32rem;
				}
			}
		}
	}
	.seation7 {
		margin: 0 0.2rem;
		height: 1rem;
		line-height: 1rem;
		background-color: #FFFFFF;
		border-bottom-left-radius: 0.16rem;
		border-bottom-right-radius: 0.16rem;
		.qb {
			margin: 0 0.2rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.qb_left {
				display: flex;
				align-items: center;
				img {
					width: 0.6rem;
					height: 0.6rem;
				}
				.word7 {
					font-family: PingFangSC-Regular;
					margin-left: 0.12rem;
					color: #6F7989;
					font-size: 0.28rem;
				}
			}
			.qb_right {
				display: flex;
				align-items: center;
				img {
					margin-left: 0.4rem;
					width: 0.14rem;
					height: 0.24rem;
				}
				.word7 {
					color: #333333;
					font-weight: 500;
					font-size: 0.32rem;
				}
			}
		}
	}
	.login_out {
		margin: 0 0.2rem;
		margin-top: 0.2rem;
		border-radius: 0.16rem;
		height: 1rem;
		line-height: 1rem;
		text-align: center;
		color: #EFBA0D;
		background-color: #FFFFFF;
		font-weight: bold;
		font-size: 0.32rem;
	}
	.kong {
		width: 100%;
		height: 1.6rem;
	}
	
	.tab_bottom {
		display: flex;
		justify-content: space-between;
		position: fixed;
		left: 0;
		bottom: 0;
		height: 1.14rem;
		width: 100%;
		background-color: #ffffff;
		border-top: 0.005rem solid #dedede;
		.tab_item {
			display: flex;
			flex-direction: column;
			align-items: center;
			margin: 0.14rem 0.8rem;
			.logo {
				width: 0.4rem;
				height: 0.4rem;
				img {
					width: 100%;
					height: 100%;
				}
			}
			.logo1 {
				width: 0.32rem;
				height: 0.4rem;
				img {
					width: 100%;
					height: 100%;
				}
			}
			.txt {
				color: #acb5bc;
				margin-top: 0.04rem;
				font-size: 0.24rem;
				transform: scale(0.916);
			}
			.active {
				color: #efba0d;
				font-family: PingFangSC-Medium;
			}
		}
	}
	.van-nav-bar__content {
		height: 1.6rem !important;
	}
</style>
